import {
  Autocomplete,
  Badge,
  Box,
  Card,
  Grid,
  Icon,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AngleRightIcon from "common/customIcons/angle_right";
import MDButton from "components/MDButton";
import EditIcon from "common/customIcons/edit";
import colors from "assets/theme/base/colors";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import InventroyTable from "../inventory";
import BatchTable from "../batch";
import Zoom from "react-medium-image-zoom";
import defaultProductImage from "../../../assets/images/placeholderproduct.svg";
import { capitalizeText } from "utilities/common";
import ProductActivityLogs from "../ProductActivityLogs";
import MDBox from "components/MDBox";
import StocksIcon from "common/customIcons/stocks";
import ProductTraits from "../productTraits";
import { isEmptyObject } from "utilities/common";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import {
  closeCustomModalDialog,
  openCustomModalDialog,
  setModalLoader,
} from "../../../redux/slices/modalSlice";
import {
  addProductStrains,
  deleteProductStrain,
  fetchProductStrains,
  fetchSingleProduct,
} from "../../../redux/slices/products";
import { openSnackbar } from "../../../redux/slices/common";
import DeleteIcon from "common/customIcons/delete";
import ActiveIcon from 'common/customIcons/active';
import InActiveIcon from 'common/customIcons/inactive';
import { getData } from "utilities/common";
import { STILO } from "utilities/constants";
import { hasSectionPermission } from "utilities/common";
import { getPermissionsByMode } from "utilities/common";

export default function ProductDetailsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { productId } = useParams();
  const { singleProduct = {}, loading } = useSelector((state) => state.products);
  const { productBatches = {} } = useSelector((state) => state.products);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const { productDetails = {} } = singleProduct || {};
  const [inventoryVersion, setInventoryVersion] = useState(0);
  const [linkState, setLinkState] = useState("")
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  const {
    productImages = [],
    productName,
    unitPrice,
    salePrice,
    categoryName,
    brandName,
    status,
    strainType,
    customWeight,
    thcData,
    productDescription,
    ingredientStatus,
    ingredients,
    instructionStatus,
    instructions,
    totalQuantity,
    holdQuantity,
    matchedStrains,
  } = productDetails || {};

  const { grey } = colors;
  const [isBatchAddOpen, setIsBatchAddOpen] = useState(false);
  const [editBatch, setEditBatch] = useState({});
  const [strainData, setStrainData] = useState([]);
  const [formData, setFormData] = useState({
    productId: "", // You might generate this automatically
    productName: "",
    productImages: [],
    status: "inactive",
    isSalePrice: false,
    unitPrice: 0,
    salePrice: "",
    categoryName: "",
    brandName: "",
    // createdBy: user?.name || '',
    tags: [],
    strainSlug: "",
    strainType: "",
    infoEffects: [],
    categoryId: "",
    sku: "",
    brandDescription: "",
    productDescription: "",
    purchaseDate: undefined,
    uniqueNumber: "",
    expirationDate: null,
    trackingSystem: "",
    purchaseQuantity: "",
    currentQuantity: "",
    unitCost: "",
    batchStatus: "active",
    ingredientStatus: false,
    ingredients: "",
    instructionStatus: false,
    instructions: "",
    strainName: [], // Initialize as empty array
    subStrainSlug: [], // Initialize as empty array
    selectedStrains: [],
  });

  const handleBatchSuccess = () => {
    dispatch(fetchSingleProduct(productId)).unwrap()
    setInventoryVersion(prev => prev + 1);
  };

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Product", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Product", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Product", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Product", "Delete");

  const showError = (message, errortype) => {
    if (errortype === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errortype === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };

  const handleSave = () => {
    const strainArray = formData.strainName.map((strain, index) => ({
      strainName: strain,
      subStrainSlug: formData.subStrainSlug[index],
    }));

    dispatch(addProductStrains({ strainArray, productId }))
      .unwrap()
      .then((res) => {
        showError(res?.message, "success");
        setFormData({
          ...formData,
          strainName: [], // Clear the strainName field after saving
          subStrainSlug: [], //
        });
        dispatch(fetchSingleProduct(productId)); // Refresh product data
      })
      .catch((err) => {
        showError(err?.message, "error");
      });
  };


  useEffect(() => {
    setTimeout(() => {
      setLinkState("")
    }, 1000);
  }, [linkState])

  const batchHandler = () => {
    setEditBatch({});
    setIsBatchAddOpen(!isBatchAddOpen);
  };

  useEffect(() => {
    setRefreshLogs(true)
  }, [productBatches])

  const queryParams = new URLSearchParams(search);
  const filter = queryParams.get("filter");
  useEffect(() => {
    if (filter === "activity_logs") {
      setIsBatchAddOpen(!isBatchAddOpen);
    }
  }, [filter]);

  useEffect(() => {
    if (!isEmptyObject(editBatch)) {
      const {
        purchaseDate,
        uniqueNumber,
        expirationDate,
        trackingSystem,
        purchaseQuantity,
        status,
        currentQuantity,
        unitCost,
      } = editBatch || {};
      setFormData({
        ...formData,
        ...{
          purchaseDate: dayjs(purchaseDate),
          uniqueNumber,
          expirationDate: expirationDate ? dayjs(expirationDate) : null,
          batchStatus: status,
          trackingSystem,
          purchaseQuantity,
          currentQuantity,
          unitCost,
        },
      });
    }
  }, [editBatch]);

  const editBatchHandler = (editData) => {
    batchHandler();
    setEditBatch(editData);
  };

  const handleAddNewStrain = () => {
    dispatch(
      openCustomModalDialog({
        modalData: { productId: productId, fetchProductStrainsData },
        modal: "ADD_NEW_STRAIN_MODAL",
      })
    );
  };

  const fetchProductStrainsData = () => {
    dispatch(fetchSingleProduct(productId)).unwrap();
  };

  useEffect(() => {
    const fetchStrains = async () => {
      try {
        const fetchStrainResponse = await dispatch(fetchProductStrains()).unwrap();
        const strainDataArray = fetchStrainResponse.data
        const filteredStrainData = strainDataArray.filter(item =>
          !matchedStrains.some(matchedItem => matchedItem.strainName === item.strainName)
        );
        setStrainData(filteredStrainData);
      } catch (error) { }
    };
    fetchStrains();
  }, [formData.strainName, matchedStrains]);


  const deleteHandler = (deleteId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteProductStrain({ productId, subStrainSlug: deleteId }))
      .unwrap()
      .then((res) => {
        showError(res?.message, "success");
        dispatch(closeCustomModalDialog());
        dispatch(fetchSingleProduct(productId)).unwrap();
      })
      .catch((err) => {
        dispatch(setModalLoader(false));
        showError(err?.message, "error");
      });
  };

  return (
    <>
      {
        canView &&
        <Box p={{ xs: 2, sm: 3, lg: 4 }} className="static-pages-container">
          <Stack direction="row" justifyContent="space-between" spacing={3} mb={3}>
            <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
              <IconButton onClick={() => navigate("/products")}>
                <AngleRightIcon fontSize="14px" />
              </IconButton>
              <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                Products
              </Typography>
            </Box>
            {
              canEdit &&
              <MDButton

                type="button"
                variant="outlined"
                color="dark"
                size="small"
                startIcon={<EditIcon width="15px" height="15px" />}
                onClick={() =>
                  navigate(
                    `/products/${singleProduct?.productDetails?.productId}?filter=products`
                  )
                }
              >
                Edit
              </MDButton>
            }

          </Stack>
          {
            <>
              <Card sx={{ p: 3, mb: 4, borderRadius: 2.5, boxShadow: "none" }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={3}
                  mb={3}
                >
                  <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A", fontSize: "1.125rem" }}>Product Information</Typography>
                  <Box display="flex" alignItems="center" gap={1.25}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      gap={0.75}
                      lineHeight={1}
                      p={0.75}
                      borderRadius={2}
                    >
                      {status === "active" && (

                        <Box color='#24CA49' display='flex' alignItems='center'>
                          <ActiveIcon width='18px' height='18px' flex='none' />
                          <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Active</Typography>
                        </Box>
                      )}
                      {status !== "active" && (
                        <Box color='#FD4438' display='flex' alignItems='center'>
                          <InActiveIcon width='18px' height='18px' flex='none' />
                          <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Inactive</Typography>
                        </Box>
                      )}
                    </Stack>
                  </Box>
                </Stack>
                {
                  !isStilo && <Stack spacing={3} direction="row">
                    <Card variant="productCard" sx={{ p: 2.5 }}>
                      <Typography variant="body2" color="dark" mb={1.5}>
                        Stock Remaining
                      </Typography>
                      <Box color="#24CA49" display="flex" alignItems="center" lineHeight={1}>
                        <MDBox
                          bgColor="#0163FF1A"
                          color="#A162F7"
                          borderRadius="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          width="44px"
                          height="44px"
                        >
                          <Icon fontSize="medium" color="inherit">
                            <StocksIcon />
                          </Icon>
                        </MDBox>
                        <Typography
                          variant="h4"
                          fontWeight="medium"
                          ml={1}
                          lineHeight={1}
                          textTransform="capitalize"
                          style={{ minWidth: "100px" }}
                        >
                          {totalQuantity}
                        </Typography>
                      </Box>
                    </Card>
                    <Card variant="productCard" sx={{ p: 2.5 }}>
                      <Typography variant="body2" color="dark" mb={1.5}>
                        Stock on Hold
                      </Typography>
                      <Box color="#24CA49" display="flex" alignItems="center" lineHeight={1}>
                        <MDBox
                          bgColor="#0163FF1A"
                          color="#A162F7"
                          borderRadius="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          width="44px"
                          height="44px"
                        >
                          <Icon fontSize="medium" color="inherit">
                            <StocksIcon />
                          </Icon>
                        </MDBox>
                        <Typography
                          variant="h4"
                          fontWeight="medium"
                          ml={1}
                          lineHeight={1}
                          textTransform="capitalize"
                          style={{ minWidth: "100px" }}
                        >
                          {holdQuantity}
                        </Typography>
                      </Box>
                    </Card>
                  </Stack>
                }



                <Stack direction="row" spacing={3} my={4}>
                  {productImages?.length > 0 ? (
                    productImages?.map((productImageUrl) => {
                      return (
                        <Zoom key={productImageUrl} classDialog="custom-zoom">
                          <img
                            key={productImageUrl}
                            style={{
                              borderRadius: "20px",
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                            }}
                            src={productImageUrl}
                            alt="No Image Found"
                          />
                        </Zoom>
                      );
                    })
                  ) : (
                    <img
                      style={{
                        borderRadius: "20px",
                        width: "160px",
                        height: "160px",
                        objectFit: "cover",
                      }}
                      src={defaultProductImage}
                      alt="No Image Found"
                    />
                  )}
                </Stack>

                <Grid container alignItems="center" spacing={{ xs: 3, md: 5 }} mb={2}>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      Product Name
                    </Typography>
                    <Box display="flex" alignItems="top" gap={1}>
                      <Typography variant="h5" fontWeight="medium" style={{ maxWidth: "calc(100% - 28px)" }}>
                        {productName ? capitalizeText(productName) : "-"}
                      </Typography>
                      <Box style={{ position: "relative" }}>
                        <svg style={{ width: "18px", height: "18px", cursor: "pointer", marginTop: "2px" }} xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"
                          onClick={() => {
                            const link = productName
                            navigator.clipboard.writeText(link)
                              .then(() => setLinkState("Link copied!"))
                              .catch(err => { });
                          }}
                        >
                          <g clipPath="url(#clip0_14557_35992)">
                            <path d="M8.61203 16.7513C6.65952 16.7513 5.07031 15.162 5.07031 13.2095V4.66797H3.61203C2.34784 4.66797 1.32031 5.69534 1.32031 6.95953V18.2095C1.32031 19.4737 2.34784 20.5013 3.61203 20.5013H14.0286C15.2928 20.5013 16.3203 19.4737 16.3203 18.2095V16.7513H8.61203Z" fill="currentColor" />
                            <path d="M19.6536 2.79172C19.6536 1.52585 18.6277 0.5 17.362 0.5H8.61203C7.34616 0.5 6.32031 1.52585 6.32031 2.79172V13.2083C6.32031 14.4742 7.34616 15.5 8.61203 15.5H17.362C18.6277 15.5 19.6536 14.4742 19.6536 13.2083V2.79172Z" fill="currentColor" />
                          </g>
                          <defs>
                            <clipPath id="clip0_14557_35992">
                              <rect width="20" height="20" fill="currentColor" transform="translate(0.5 0.5)" />
                            </clipPath>
                          </defs>
                        </svg>
                        {
                          linkState &&
                          <p className="link-status" style={{ backgroundColor: "#f2f2f2", top: "-30px" }}>{linkState}</p>
                        }
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      Unit Price
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      ${unitPrice || 0}{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      Sale Price
                    </Typography>

                    <Typography
                      variant="h5"
                      fontWeight="medium"
                      display="flex"
                      alignItems="center"
                      gap={0.75}
                    >
                      {salePrice ? (
                        <>
                          <svg
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect width="8" height="8" rx="4" fill="#24CA49" />
                          </svg>
                          {`$${salePrice}`}
                        </>
                      ) : (
                        "-"
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      Category
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {categoryName || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      Brand name
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {brandName || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      Strain Type
                    </Typography>
                    <Typography variant='h6' fontWeight="medium">
                      {strainType === 'Indica-dominant Hybrid'
                        ? 'Indica / Hybrid'
                        : strainType === 'Sativa-dominant Hybrid'
                          ? 'Sativa / Hybrid'
                          : (strainType || "-")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      Product Weight ({customWeight?.includes("mg") ? "mg" : "g"})
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {customWeight || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={3}>
                    <Typography variant="body2" color={grey[600]}>
                      THC ({thcData?.includes("%") ? "%" : "mg"})
                    </Typography>
                    <Typography variant="h5" fontWeight="medium" lineHeight="1.25">
                      {thcData || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" color={grey[600]}>
                      Description
                    </Typography>
                    <Typography
                      className="quill-text-editor-view"
                      component="div"
                      fontWeight="medium"
                      variant="h6"
                    >
                      {productDescription ? (
                        <div dangerouslySetInnerHTML={{ __html: productDescription }} />
                      ) : (
                        "-"
                      )}
                    </Typography>
                  </Grid>
                  {ingredientStatus && (
                    <Grid item xs={12}>
                      <Typography variant="body2" color={grey[600]}>
                        Ingredients
                      </Typography>
                      <Typography
                        className="quill-text-editor-view"
                        component="div"
                        fontWeight="medium"
                        variant="h6"
                      >
                        {ingredients ? (
                          <div dangerouslySetInnerHTML={{ __html: ingredients }} />
                        ) : (
                          "-"
                        )}
                      </Typography>
                    </Grid>
                  )}
                  {instructionStatus && (
                    <Grid item xs={12}>
                      <Typography variant="body2" color={grey[600]}>
                        Instructions for use
                      </Typography>
                      <Typography
                        className="quill-text-editor-view"
                        component="div"
                        fontWeight="medium"
                        variant="h6"
                      >
                        {instructions ? (
                          <div dangerouslySetInnerHTML={{ __html: instructions }} />
                        ) : (
                          "-"
                        )}
                      </Typography>
                    </Grid>
                  )}
                </Grid>

                <Grid item xs={12} md={12} className="mb-2">
                  <Typography variant="body2" color={grey[600]}>Genetics (Strains)</Typography>
                </Grid>

                <Grid container spacing={2} xs={12} md={12} className="bg-grey m-0 genetics-strains-sec">
                  <Grid container spacing={2} xs={12} md={12}>
                    <Grid item={12}>
                      {matchedStrains?.map((strain, index) => (
                        <Badge key={index}>
                          <div className="badge-inner">
                            {strain.strainName}
                            <IconButton
                              onClick={() =>
                                dispatch(
                                  openCustomModalDialog({
                                    modalData: {
                                      deleteHandler,
                                      deleteId: strain.subStrainSlug,
                                      deleteType: "product strain",
                                    },
                                    modal: "DELETE_MODAL",
                                  })
                                )
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </div>
                        </Badge>
                      ))}
                    </Grid>
                  </Grid>
                  {
                    (canEdit || canCreate) &&
                    <Grid container xs={12} md={12} className="mt-3 align-center select-multi-strain">
                      <Grid item xs={12}>
                        <div className="select-strain-sec">
                          <Autocomplete
                            multiple
                            id="strain-autocomplete"
                            options={[{ strainName: "+ Add new strain" }, ...(strainData || [])]}
                            getOptionLabel={(option) => option.strainName}
                            filterSelectedOptions
                            onChange={(event, selectedOptions) => {
                              const hasAddNew = selectedOptions.some(
                                (opt) => opt.strainName === "+ Add new strain"
                              );
                              if (hasAddNew) {
                                handleAddNewStrain();
                                // Remove "Add new strain" from selected options to prevent it from being displayed
                                const filteredOptions = selectedOptions.filter(
                                  (opt) => opt.strainName !== "+ Add new strain"
                                );
                                setFormData((prev) => ({
                                  ...prev,
                                  strainName: filteredOptions.map((opt) => opt.strainName),
                                  subStrainSlug: filteredOptions.map((opt) => opt.subStrainSlug),
                                }));
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  strainName: selectedOptions.map((opt) => opt.strainName),
                                  subStrainSlug: selectedOptions.map((opt) => opt.subStrainSlug),
                                }));
                              }
                            }}
                            value={formData.strainName.map(
                              (name) =>
                                strainData.find((strain) => strain.strainName === name) || {
                                  strainName: name,
                                }
                            )}
                            renderInput={(params) => <TextField {...params} label="Select Strain" />}
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                style={{
                                  color: option.strainName === "+ Add new strain" ? "#0163FF" : "inherit", // Apply blue color to "Add new strain"
                                }}
                              >
                                {option.strainName}
                              </li>
                            )}
                          />
                          {formData.strainName.length > 0 && (
                            <MDButton
                              onClick={handleSave}
                              // size="small"
                              className="mr-3 primay-btn"
                              color="primary"
                              loading={loading}
                              disabled={loading}
                              style={{ minWidth: "100px" }}
                            >
                              Save
                            </MDButton>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  }
                </Grid>
              </Card>
            </>
          }
          {

          }

          <ProductTraits canCreate={canCreate} canEdit={canEdit} canDelete={canDelete} />

          {
            !isStilo &&
            <>
              <InventroyTable
                canCreate={canCreate} canEdit={canEdit} canDelete={canDelete}
                productId={productId}
                totalProduct={singleProduct?.productDetails?.totalQuantity}
              />

              <Box my={2}>
                <BatchTable
                  canEdit={canEdit} canDelete={canDelete}
                  canCreate={canCreate}
                  formRender={editBatch}
                  batchHandler={batchHandler}
                  editBatchHandler={editBatchHandler}
                  productId={productId}
                  onBatchSuccess={handleBatchSuccess}
                />
              </Box>

              <ProductActivityLogs inventoryVersion={inventoryVersion} />
            </>
          }
        </Box>
      }
    </>
  );
}
